import type { UserCredential } from 'firebase/auth';
import { FirebaseError } from 'firebase/app';
import { firebaseAuthService } from '@/core/services';

export class VincularTelefoneAContaUseCase {
  async execute(params: { verificationId: string; code: string }): Promise<UserCredential> {
    const user = firebaseAuthService.getAuth().currentUser;
    if (!user) {
      throw new FirebaseError('auth/no-current-user', 'Nenhum usuário autenticado.');
    }

    return firebaseAuthService.linkPhoneNumberToCurrentUserWithCredential(params);
  }
}

